import { render, staticRenderFns } from "./RRApplicationLegalEditModal.vue?vue&type=template&id=54e1caf1&scoped=true&"
import script from "./RRApplicationLegalEditModal.vue?vue&type=script&lang=js&"
export * from "./RRApplicationLegalEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1caf1",
  null
  
)

export default component.exports